import { AnalyticsBrowser } from "@segment/analytics-next";
import posthog from "posthog-js";

// Initialize only once to avoid duplicate initialization
let analytics: AnalyticsBrowser | undefined;

// Initialize analytics with your Segment write key
export const getAnalytics = () => {
  const writeKey = process.env.NEXT_PUBLIC_SEGMENT_WRITE_KEY;

  if (!writeKey) {
    console.warn(
      "Segment write key is not defined. Analytics will not be initialized.",
    );
    return null;
  }

  if (!analytics && typeof window !== "undefined") {
    analytics = AnalyticsBrowser.load({ writeKey });
  }

  return analytics;
};

// Track a user event
export const trackEvent = (
  event: string,
  properties?: Record<string, unknown>,
) => {
  const analytics = getAnalytics();
  if (analytics) {
    analytics.track(event, properties);
  }
};

// Identify a user
// PostHog calls stay outside the Segment guard: getAnalytics() returns null
// whenever NEXT_PUBLIC_SEGMENT_WRITE_KEY is unset, and nesting them there left
// personal staging sending anonymous, ungrouped PostHog data while appearing to
// work.
export const identifyUser = (
  userId: string,
  traits?: Record<string, unknown>,
) => {
  getAnalytics()?.identify(userId, traits);
  posthog.identify(userId, traits);
};

export const identifyOrganization = (
  organizationId: string,
  traits?: Record<string, unknown>,
) => {
  if (!organizationId) return;
  posthog.group("organization", organizationId, traits);
};

// Track page views
export const trackPageView = (
  name?: string,
  properties?: Record<string, unknown>,
) => {
  const analytics = getAnalytics();
  if (analytics) {
    analytics.page(name, properties);
  }
};

// Reset user identification (for logout)
// Without posthog.reset() the distinct_id survives logout, so the next user on
// the same browser is merged into the previous person.
export const resetUser = () => {
  getAnalytics()?.reset();
  posthog.reset();
};
